import {
  ViewBase
} from 'mutants-appfx';
import {
  Modal
} from 'tinper-bee';
import {
  i18n
} from 'mutants-microfx';
const t = i18n.getFixedT(null, 'posTouch');

// 统一UI行为（可以在业务controller里调用的）的适配，比如反馈
export default class UIAdapter extends ViewBase {
  async triggerFeedback(message, type) {
    if (Modal[type]) {
      return await new Promise((resolve)=>{
        Modal[type]({
          title: t('温情提示'),
          content: message,
          onOk() {
            resolve({
              result: 'OK'
            })
          },
          onCancel() {
            resolve({
              result: 'Cancel'
            })
          },
        })
      });
    }
  }

  static fromJS(store) {
     return new UIAdapter(store);
  }
}
